"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.userInfo.avatar;
  },
  name: function name(state) {
    return state.user.name;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permissions_button: function permissions_button(state) {
    return state.user.permissions_button;
  },
  permission: function permission(state) {
    return state.permission.addRoutes;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  topbarRouters: function topbarRouters(state) {
    return state.permission.topbarRouters;
  },
  sidebarRouters: function sidebarRouters(state) {
    return state.permission.sidebarRouters;
  }
};
var _default = getters;
exports.default = _default;